<template>
  <div class="wrapper">
    <svg
      class="leaf-wrap"
      data-testid="loading-spinner"
      height="80"
      viewBox="0 0 32 32"
      width="80"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="none" fill-rule="evenodd">
        <path
          class="leaf"
          d="M10.1481672,2.68992044 C11.6790568,1.10335985 14.1611192,1.10335985 15.6920088,2.68992044 C15.7962622,2.79796499 15.8934159,2.91058111 15.98347,3.02714615 L16,3.00911178 L16.0170803,3.02643399 C16.1069799,2.91012241 16.2039502,2.79774494 16.3079912,2.68992044 C17.8388808,1.10335985 20.3209432,1.10335985 21.8518328,2.68992044 C23.3827224,4.27648102 23.3827224,6.84880397 21.8518328,8.43536455 L16,14.5 L10.1481672,8.43536455 C8.6172776,6.84880397 8.6172776,4.27648102 10.1481672,2.68992044 Z"
          fill="#00E38E"
        />
        <path
          class="leaf"
          d="M29.3100796,10.1481672 C30.8966402,11.6790568 30.8966402,14.1611192 29.3100796,15.6920088 C29.202035,15.7962622 29.0894189,15.8934159 28.9728539,15.98347 L28.9908882,16 L28.973566,16.0170803 C29.0898776,16.1069799 29.2022551,16.2039502 29.3100796,16.3079912 C30.8966402,17.8388808 30.8966402,20.3209432 29.3100796,21.8518328 C27.723519,23.3827224 25.151196,23.3827224 23.5646355,21.8518328 L17.5,16 L23.5646355,10.1481672 C25.151196,8.6172776 27.723519,8.6172776 29.3100796,10.1481672 Z"
          fill="#FF2457"
        />
        <path
          class="leaf"
          d="M21.8518328,29.3100796 C20.3209432,30.8966401 17.8388808,30.8966401 16.3079912,29.3100796 C16.2037378,29.202035 16.1065841,29.0894189 16.01653,28.9728539 L16,28.9908882 L15.9829197,28.973566 C15.8930201,29.0898776 15.7960498,29.2022551 15.6920088,29.3100796 C14.1611192,30.8966401 11.6790568,30.8966401 10.1481672,29.3100796 C8.6172776,27.723519 8.6172776,25.151196 10.1481672,23.5646355 L16,17.5 L21.8518328,23.5646355 C23.3827224,25.151196 23.3827224,27.723519 21.8518328,29.3100796 Z"
          fill="#FFD300"
        />
        <path
          class="leaf"
          d="M2.6899204,21.8518328 C1.10335985,20.3209432 1.10335985,17.8388808 2.6899204,16.3079912 C2.797965,16.2037378 2.9105811,16.1065841 3.0271461,16.01653 L3.0091118,16 L3.026434,15.9829197 C2.9101224,15.8930201 2.7977449,15.7960498 2.6899204,15.6920088 C1.10335985,14.1611192 1.10335985,11.6790568 2.6899204,10.1481672 C4.276481,8.6172776 6.848804,8.6172776 8.4353645,10.1481672 L14.5,16 L8.4353645,21.8518328 C6.848804,23.3827224 4.276481,23.3827224 2.6899204,21.8518328 Z"
          fill="#10BFFF"
        />
      </g>
    </svg>
  </div>
</template>

<style lang="scss" scoped>
.wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  width: 100%;
  height: 100%;
}

.leaf-wrap {
  overflow: visible;
  perspective: initial;
}

.leaf {
  transform-origin: center;
  animation-duration: 2s;
  animation-timing-function: cubic-bezier(0.4, 0.14, 0.3, 1);
  animation-iteration-count: infinite;
  transform-style: preserve-3d;
}

.leaf:first-of-type {
  animation-name: bounce-top;
}

.leaf:nth-of-type(2) {
  animation-name: bounce-right;
  animation-delay: 0.5s;
}

.leaf:nth-of-type(3) {
  animation-name: bounce-bottom;
  animation-delay: 1s;
}

.leaf:last-of-type {
  animation-name: bounce-left;
  animation-delay: 1.5s;
}

@keyframes bounce-top {
  0% {
    transform: scale(1, 1) translateY(0) rotateY(0deg);
  }

  5% {
    transform: scale(1.1, 0.9) translateY(0);
  }

  12.5% {
    transform: scale(0.9, 1.1) translateY(-5px) rotateY(180deg);
  }

  15% {
    transform: scale(1.05, 0.95) translateY(0);
  }

  20% {
    transform: scale(1, 1) translateY(-1px);
  }

  25% {
    transform: scale(1, 1) translateY(0) rotateY(0deg);
  }

  100% {
    transform: scale(1, 1) translateY(0) rotateY(0deg);
  }
}

@keyframes bounce-right {
  0% {
    transform: scale(1, 1) translateX(0) rotateX(0deg);
  }

  5% {
    transform: scale(1.1, 0.9) translateX(0);
  }

  12.5% {
    transform: scale(0.9, 1.1) translateX(5px) rotateX(180deg);
  }

  15% {
    transform: scale(1.05, 0.95) translateX(0);
  }

  20% {
    transform: scale(1, 1) translateX(1px);
  }

  25% {
    transform: scale(1, 1) translateX(0) rotateX(0deg);
  }

  100% {
    transform: scale(1, 1) translateY(0) rotateX(0deg);
  }
}

@keyframes bounce-bottom {
  0% {
    transform: scale(1, 1) translateY(0) rotateY(0deg);
  }

  5% {
    transform: scale(1.1, 0.9) translateY(0);
  }

  12.5% {
    transform: scale(0.9, 1.1) translateY(5px) rotateY(180deg);
  }

  15% {
    transform: scale(1.05, 0.95) translateY(0);
  }

  20% {
    transform: scale(1, 1) translateY(1px);
  }

  25% {
    transform: scale(1, 1) translateY(0) rotateY(0deg);
  }

  100% {
    transform: scale(1, 1) translateY(0) rotateY(0deg);
  }
}

@keyframes bounce-left {
  0% {
    transform: scale(1, 1) translateX(0);
  }

  5% {
    transform: scale(1.1, 0.9) translateX(0);
  }

  12.5% {
    transform: scale(0.9, 1.1) translateX(-5px) rotateX(180deg);
  }

  15% {
    transform: scale(1.05, 0.95) translateX(0);
  }

  20% {
    transform: scale(1, 1) translateX(-1px);
  }

  25% {
    transform: scale(1, 1) translateX(0) rotateX(0deg);
  }

  100% {
    transform: scale(1, 1) translateY(0) rotateX(0deg);
  }
}
</style>
